import { useEffect } from 'react';

import { CameraConnectionIssueReason } from 'src/services/posthogEvents';
import { reportCameraConnectionIssue } from 'src/services/reportCameraConnectionIssue';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { useGetCurrentCaptureProcess } from './useGetCurrentCaptureProcess';

export function useCameraHeartbeatWatch({
  enabled = true,
}: { enabled?: boolean } = {}): void {
  const { error } = useGetCurrentCaptureProcess();

  useEffect(() => {
    if (!enabled || !error) return;

    const { cameraConnectionIssueReason, isCapturing } =
      useRemoteBoundStore.getState();
    if (isCapturing) return;
    if (!cameraConnectionIssueReason) {
      reportCameraConnectionIssue(CameraConnectionIssueReason.LOST_HEARTBEAT);
    }
  }, [enabled, error]);
}
